// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from './client';
import type { PostAccountGetApplicationServiceTokenData, PostAccountGetApplicationServiceTokenResponses, PostAccountGetApplicationServiceTokenErrors, PostAccountCreateAccessTokenData, PostAccountCreateAccessTokenResponses, PostAccountCreateAccessTokenErrors, PostAccountCreateUncheckedUserTokenData, PostAccountCreateUncheckedUserTokenResponses, PostAccountCreateUncheckedUserTokenErrors, GetAccountGetCachedUserInfoData, GetAccountGetCachedUserInfoResponses, GetAccountGetCachedUserInfoErrors, GetAccountGetDebugCachedUserInfoData, GetAccountGetDebugCachedUserInfoResponses, GetAccountGetDebugCachedUserInfoErrors, PostCompositionCreateSubscriptionData, PostCompositionCreateSubscriptionResponses, PostCompositionCreateSubscriptionErrors, PostCompositionVerifyIdentificationDocumentData, PostCompositionVerifyIdentificationDocumentResponses, PostCompositionVerifyIdentificationDocumentErrors, GetCompositionGetSubscriptionStateData, GetCompositionGetSubscriptionStateResponses, GetCompositionGetSubscriptionStateErrors, PostCompositionUploadSignedFileData, PostCompositionUploadSignedFileResponses, PostCompositionUploadSignedFileErrors, GetCompositionGetPrivacyTemplateData, GetCompositionGetPrivacyTemplateResponses, GetCompositionGetPrivacyTemplateErrors, GetCompositionGetRevocationTemplateData, GetCompositionGetRevocationTemplateResponses, GetCompositionGetRevocationTemplateErrors, GetCompositionCheckPrivacyTemplateData, GetCompositionCheckPrivacyTemplateResponses, GetCompositionCheckPrivacyTemplateErrors, GetCompositionCheckRevocationTemplateData, GetCompositionCheckRevocationTemplateResponses, GetCompositionCheckRevocationTemplateErrors, PostCompositionPreviewContractData, PostCompositionPreviewContractResponses, PostCompositionPreviewContractErrors, PostCompositionUpdateSubscriptionData, PostCompositionUpdateSubscriptionResponses, PostCompositionUpdateSubscriptionErrors, GetCompositionGetSubscriptionData, GetCompositionGetSubscriptionResponses, GetCompositionGetSubscriptionErrors, GetCompositionGetDocumentPreviewData, GetCompositionGetDocumentPreviewResponses, GetCompositionGetDocumentPreviewErrors, GetCompositionGetUserDataByLinkedIdData, GetCompositionGetUserDataByLinkedIdResponses, GetCompositionGetUserDataByLinkedIdErrors, PostMfaSendOtpData, PostMfaSendOtpResponses, PostMfaSendOtpErrors, PostMfaValidateOtpData, PostMfaValidateOtpResponses, PostMfaValidateOtpErrors, GetNotificationByNotificationIdData, GetNotificationByNotificationIdResponses, GetNotificationByNotificationIdErrors, GetSigningGetSubscriptionSealData, GetSigningGetSubscriptionSealResponses, GetSigningGetSubscriptionSealErrors, PostSigningSealDocumentData, PostSigningSealDocumentResponses, PostSigningSealDocumentErrors, PostSubscriptionManagementSearchSubscriptionsData, PostSubscriptionManagementSearchSubscriptionsResponses, PostSubscriptionManagementSearchSubscriptionsErrors, GetSubscriptionManagementGetDocumentPreviewData, GetSubscriptionManagementGetDocumentPreviewResponses, GetSubscriptionManagementGetDocumentPreviewErrors, PostSubscriptionManagementApproveSubscriptionData, PostSubscriptionManagementApproveSubscriptionResponses, PostSubscriptionManagementApproveSubscriptionErrors, PostSubscriptionManagementRefuseSubscriptionData, PostSubscriptionManagementRefuseSubscriptionResponses, PostSubscriptionManagementRefuseSubscriptionErrors, PostSubscriptionManagementRevokeSubscriptionData, PostSubscriptionManagementRevokeSubscriptionResponses, PostSubscriptionManagementRevokeSubscriptionErrors, GetTenantAdministrationGetTenantApproversData, GetTenantAdministrationGetTenantApproversResponses, GetTenantAdministrationGetTenantApproversErrors, PostTenantAdministrationCreateTenantApproverData, PostTenantAdministrationCreateTenantApproverResponses, PostTenantAdministrationCreateTenantApproverErrors, PostTenantAdministrationUpdateTenantApproverData, PostTenantAdministrationUpdateTenantApproverResponses, PostTenantAdministrationUpdateTenantApproverErrors, PostTenantAdministrationDeleteTenantApproverData, PostTenantAdministrationDeleteTenantApproverResponses, PostTenantAdministrationDeleteTenantApproverErrors, GetTenantAdministrationGetSealsData, GetTenantAdministrationGetSealsResponses, GetTenantAdministrationGetSealsErrors, PostTenantAdministrationCreateSealData, PostTenantAdministrationCreateSealResponses, PostTenantAdministrationCreateSealErrors, PostTenantAdministrationUpdateSealData, PostTenantAdministrationUpdateSealResponses, PostTenantAdministrationUpdateSealErrors, PostTenantAdministrationDeleteSealData, PostTenantAdministrationDeleteSealResponses, PostTenantAdministrationDeleteSealErrors, GetTenantAdministrationGetSealDefinitionsData, GetTenantAdministrationGetSealDefinitionsResponses, GetTenantAdministrationGetSealDefinitionsErrors, PostTenantAdministrationUpsertUserDataData, PostTenantAdministrationUpsertUserDataResponses, PostTenantAdministrationUpsertUserDataErrors, PostUnattendedCompositionCreateSubscriptionData, PostUnattendedCompositionCreateSubscriptionResponses, PostUnattendedCompositionCreateSubscriptionErrors, GetData, GetResponses, DeleteYubiqAdministrationDeleteSubscriptionData, DeleteYubiqAdministrationDeleteSubscriptionResponses, DeleteYubiqAdministrationDeleteSubscriptionErrors, PostYubiqAdministrationCreateTenantData, PostYubiqAdministrationCreateTenantResponses, PostYubiqAdministrationCreateTenantErrors, PostYubiqAdministrationUpdateTenantData, PostYubiqAdministrationUpdateTenantResponses, PostYubiqAdministrationUpdateTenantErrors, PostYubiqAdministrationDisableTenantData, PostYubiqAdministrationDisableTenantResponses, PostYubiqAdministrationDisableTenantErrors, GetYubiqAdministrationGetAllTenantsData, GetYubiqAdministrationGetAllTenantsResponses, GetYubiqAdministrationGetAllTenantsErrors, GetYubiqAdministrationGetSealsData, GetYubiqAdministrationGetSealsResponses, GetYubiqAdministrationGetSealsErrors, PostYubiqAdministrationCreateSealData, PostYubiqAdministrationCreateSealResponses, PostYubiqAdministrationCreateSealErrors, PostYubiqAdministrationUpdateSealData, PostYubiqAdministrationUpdateSealResponses, PostYubiqAdministrationUpdateSealErrors, PostYubiqAdministrationDeleteSealData, PostYubiqAdministrationDeleteSealResponses, PostYubiqAdministrationDeleteSealErrors, GetYubiqAdministrationGetSealDefinitionsData, GetYubiqAdministrationGetSealDefinitionsResponses, GetYubiqAdministrationGetSealDefinitionsErrors, PostYubiqAdministrationCreateTenantDocumentData, PostYubiqAdministrationCreateTenantDocumentResponses, PostYubiqAdministrationCreateTenantDocumentErrors, GetYubiqAdministrationGetTenantDocumentByIdData, GetYubiqAdministrationGetTenantDocumentByIdResponses, GetYubiqAdministrationGetTenantDocumentByIdErrors, GetYubiqAdministrationGetTenantDocumentsData, GetYubiqAdministrationGetTenantDocumentsResponses, GetYubiqAdministrationGetTenantDocumentsErrors, PostYubiqAdministrationDeleteTenantDocumentData, PostYubiqAdministrationDeleteTenantDocumentResponses, PostYubiqAdministrationDeleteTenantDocumentErrors, GetYubiqAdministrationGetTenantHierarchyEdgesData, GetYubiqAdministrationGetTenantHierarchyEdgesResponses, GetYubiqAdministrationGetTenantHierarchyEdgesErrors, PostYubiqAdministrationCreateTenantHierarchyEdgeData, PostYubiqAdministrationCreateTenantHierarchyEdgeResponses, PostYubiqAdministrationCreateTenantHierarchyEdgeErrors, PostYubiqAdministrationDisableTenantHierarchyEdgeData, PostYubiqAdministrationDisableTenantHierarchyEdgeResponses, PostYubiqAdministrationDisableTenantHierarchyEdgeErrors, GetYubiqAdministrationGetTenantHierarchyEdgeData, GetYubiqAdministrationGetTenantHierarchyEdgeResponses, GetYubiqAdministrationGetTenantHierarchyEdgeErrors } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const postAccountGetApplicationServiceToken = <ThrowOnError extends boolean = false>(options?: Options<PostAccountGetApplicationServiceTokenData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostAccountGetApplicationServiceTokenResponses, PostAccountGetApplicationServiceTokenErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Account/GetApplicationServiceToken',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postAccountCreateAccessToken = <ThrowOnError extends boolean = false>(options?: Options<PostAccountCreateAccessTokenData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostAccountCreateAccessTokenResponses, PostAccountCreateAccessTokenErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Account/CreateAccessToken',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postAccountCreateUncheckedUserToken = <ThrowOnError extends boolean = false>(options?: Options<PostAccountCreateUncheckedUserTokenData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostAccountCreateUncheckedUserTokenResponses, PostAccountCreateUncheckedUserTokenErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Account/CreateUncheckedUserToken',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getAccountGetCachedUserInfo = <ThrowOnError extends boolean = false>(options?: Options<GetAccountGetCachedUserInfoData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAccountGetCachedUserInfoResponses, GetAccountGetCachedUserInfoErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Account/GetCachedUserInfo',
        ...options
    });
};

export const getAccountGetDebugCachedUserInfo = <ThrowOnError extends boolean = false>(options?: Options<GetAccountGetDebugCachedUserInfoData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAccountGetDebugCachedUserInfoResponses, GetAccountGetDebugCachedUserInfoErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Account/GetDebugCachedUserInfo',
        ...options
    });
};

export const postCompositionCreateSubscription = <ThrowOnError extends boolean = false>(options?: Options<PostCompositionCreateSubscriptionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostCompositionCreateSubscriptionResponses, PostCompositionCreateSubscriptionErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Composition/CreateSubscription',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

export const postCompositionVerifyIdentificationDocument = <ThrowOnError extends boolean = false>(options?: Options<PostCompositionVerifyIdentificationDocumentData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostCompositionVerifyIdentificationDocumentResponses, PostCompositionVerifyIdentificationDocumentErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Composition/VerifyIdentificationDocument',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

export const getCompositionGetSubscriptionState = <ThrowOnError extends boolean = false>(options?: Options<GetCompositionGetSubscriptionStateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCompositionGetSubscriptionStateResponses, GetCompositionGetSubscriptionStateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Composition/GetSubscriptionState',
        ...options
    });
};

export const postCompositionUploadSignedFile = <ThrowOnError extends boolean = false>(options?: Options<PostCompositionUploadSignedFileData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostCompositionUploadSignedFileResponses, PostCompositionUploadSignedFileErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Composition/UploadSignedFile',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

export const getCompositionGetPrivacyTemplate = <ThrowOnError extends boolean = false>(options?: Options<GetCompositionGetPrivacyTemplateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCompositionGetPrivacyTemplateResponses, GetCompositionGetPrivacyTemplateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Composition/GetPrivacyTemplate',
        ...options
    });
};

export const getCompositionGetRevocationTemplate = <ThrowOnError extends boolean = false>(options?: Options<GetCompositionGetRevocationTemplateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCompositionGetRevocationTemplateResponses, GetCompositionGetRevocationTemplateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Composition/GetRevocationTemplate',
        ...options
    });
};

/**
 * Checks whether the tenant-specific privacy template exists.
 */
export const getCompositionCheckPrivacyTemplate = <ThrowOnError extends boolean = false>(options?: Options<GetCompositionCheckPrivacyTemplateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCompositionCheckPrivacyTemplateResponses, GetCompositionCheckPrivacyTemplateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Composition/CheckPrivacyTemplate',
        ...options
    });
};

/**
 * Checks whether the tenant-specific revocation template exists.
 */
export const getCompositionCheckRevocationTemplate = <ThrowOnError extends boolean = false>(options?: Options<GetCompositionCheckRevocationTemplateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCompositionCheckRevocationTemplateResponses, GetCompositionCheckRevocationTemplateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Composition/CheckRevocationTemplate',
        ...options
    });
};

export const postCompositionPreviewContract = <ThrowOnError extends boolean = false>(options?: Options<PostCompositionPreviewContractData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostCompositionPreviewContractResponses, PostCompositionPreviewContractErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Composition/PreviewContract',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postCompositionUpdateSubscription = <ThrowOnError extends boolean = false>(options?: Options<PostCompositionUpdateSubscriptionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostCompositionUpdateSubscriptionResponses, PostCompositionUpdateSubscriptionErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Composition/UpdateSubscription',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

export const getCompositionGetSubscription = <ThrowOnError extends boolean = false>(options?: Options<GetCompositionGetSubscriptionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCompositionGetSubscriptionResponses, GetCompositionGetSubscriptionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Composition/GetSubscription',
        ...options
    });
};

export const getCompositionGetDocumentPreview = <ThrowOnError extends boolean = false>(options: Options<GetCompositionGetDocumentPreviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCompositionGetDocumentPreviewResponses, GetCompositionGetDocumentPreviewErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Composition/GetDocumentPreview',
        ...options
    });
};

/**
 * Retrieve preloaded user data by linked identifier.
 * Restricted to TenantAdministrator actors.
 */
export const getCompositionGetUserDataByLinkedId = <ThrowOnError extends boolean = false>(options?: Options<GetCompositionGetUserDataByLinkedIdData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCompositionGetUserDataByLinkedIdResponses, GetCompositionGetUserDataByLinkedIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Composition/GetUserDataByLinkedId',
        ...options
    });
};

export const postMfaSendOtp = <ThrowOnError extends boolean = false>(options?: Options<PostMfaSendOtpData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostMfaSendOtpResponses, PostMfaSendOtpErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/MFA/SendOtp',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postMfaValidateOtp = <ThrowOnError extends boolean = false>(options?: Options<PostMfaValidateOtpData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostMfaValidateOtpResponses, PostMfaValidateOtpErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/MFA/ValidateOTP',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getNotificationByNotificationId = <ThrowOnError extends boolean = false>(options: Options<GetNotificationByNotificationIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetNotificationByNotificationIdResponses, GetNotificationByNotificationIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Notification/{notificationId}',
        ...options
    });
};

export const getSigningGetSubscriptionSeal = <ThrowOnError extends boolean = false>(options?: Options<GetSigningGetSubscriptionSealData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSigningGetSubscriptionSealResponses, GetSigningGetSubscriptionSealErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Signing/GetSubscriptionSeal',
        ...options
    });
};

export const postSigningSealDocument = <ThrowOnError extends boolean = false>(options?: Options<PostSigningSealDocumentData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostSigningSealDocumentResponses, PostSigningSealDocumentErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/Signing/SealDocument',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

export const postSubscriptionManagementSearchSubscriptions = <ThrowOnError extends boolean = false>(options?: Options<PostSubscriptionManagementSearchSubscriptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostSubscriptionManagementSearchSubscriptionsResponses, PostSubscriptionManagementSearchSubscriptionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/SubscriptionManagement/SearchSubscriptions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getSubscriptionManagementGetDocumentPreview = <ThrowOnError extends boolean = false>(options: Options<GetSubscriptionManagementGetDocumentPreviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSubscriptionManagementGetDocumentPreviewResponses, GetSubscriptionManagementGetDocumentPreviewErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/SubscriptionManagement/GetDocumentPreview',
        ...options
    });
};

export const postSubscriptionManagementApproveSubscription = <ThrowOnError extends boolean = false>(options?: Options<PostSubscriptionManagementApproveSubscriptionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostSubscriptionManagementApproveSubscriptionResponses, PostSubscriptionManagementApproveSubscriptionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/SubscriptionManagement/ApproveSubscription',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postSubscriptionManagementRefuseSubscription = <ThrowOnError extends boolean = false>(options?: Options<PostSubscriptionManagementRefuseSubscriptionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostSubscriptionManagementRefuseSubscriptionResponses, PostSubscriptionManagementRefuseSubscriptionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/SubscriptionManagement/RefuseSubscription',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postSubscriptionManagementRevokeSubscription = <ThrowOnError extends boolean = false>(options?: Options<PostSubscriptionManagementRevokeSubscriptionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostSubscriptionManagementRevokeSubscriptionResponses, PostSubscriptionManagementRevokeSubscriptionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/SubscriptionManagement/RevokeSubscription',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getTenantAdministrationGetTenantApprovers = <ThrowOnError extends boolean = false>(options?: Options<GetTenantAdministrationGetTenantApproversData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTenantAdministrationGetTenantApproversResponses, GetTenantAdministrationGetTenantApproversErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/TenantAdministration/GetTenantApprovers',
        ...options
    });
};

export const postTenantAdministrationCreateTenantApprover = <ThrowOnError extends boolean = false>(options?: Options<PostTenantAdministrationCreateTenantApproverData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostTenantAdministrationCreateTenantApproverResponses, PostTenantAdministrationCreateTenantApproverErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/TenantAdministration/CreateTenantApprover',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postTenantAdministrationUpdateTenantApprover = <ThrowOnError extends boolean = false>(options?: Options<PostTenantAdministrationUpdateTenantApproverData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostTenantAdministrationUpdateTenantApproverResponses, PostTenantAdministrationUpdateTenantApproverErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/TenantAdministration/UpdateTenantApprover',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postTenantAdministrationDeleteTenantApprover = <ThrowOnError extends boolean = false>(options?: Options<PostTenantAdministrationDeleteTenantApproverData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostTenantAdministrationDeleteTenantApproverResponses, PostTenantAdministrationDeleteTenantApproverErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/TenantAdministration/DeleteTenantApprover',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getTenantAdministrationGetSeals = <ThrowOnError extends boolean = false>(options?: Options<GetTenantAdministrationGetSealsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTenantAdministrationGetSealsResponses, GetTenantAdministrationGetSealsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/TenantAdministration/GetSeals',
        ...options
    });
};

export const postTenantAdministrationCreateSeal = <ThrowOnError extends boolean = false>(options?: Options<PostTenantAdministrationCreateSealData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostTenantAdministrationCreateSealResponses, PostTenantAdministrationCreateSealErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/TenantAdministration/CreateSeal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postTenantAdministrationUpdateSeal = <ThrowOnError extends boolean = false>(options?: Options<PostTenantAdministrationUpdateSealData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostTenantAdministrationUpdateSealResponses, PostTenantAdministrationUpdateSealErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/TenantAdministration/UpdateSeal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postTenantAdministrationDeleteSeal = <ThrowOnError extends boolean = false>(options?: Options<PostTenantAdministrationDeleteSealData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostTenantAdministrationDeleteSealResponses, PostTenantAdministrationDeleteSealErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/TenantAdministration/DeleteSeal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getTenantAdministrationGetSealDefinitions = <ThrowOnError extends boolean = false>(options?: Options<GetTenantAdministrationGetSealDefinitionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTenantAdministrationGetSealDefinitionsResponses, GetTenantAdministrationGetSealDefinitionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/TenantAdministration/GetSealDefinitions',
        ...options
    });
};

/**
 * Upsert preloaded user data for subscription creation forms.
 * Restricted to TenantAdministrator actors.
 */
export const postTenantAdministrationUpsertUserData = <ThrowOnError extends boolean = false>(options?: Options<PostTenantAdministrationUpsertUserDataData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostTenantAdministrationUpsertUserDataResponses, PostTenantAdministrationUpsertUserDataErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/TenantAdministration/UpsertUserData',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Creates a subscription through the unattended creation stack.
 * Only TenantAdministrator actor is authorized. No document upload or OTP required.
 */
export const postUnattendedCompositionCreateSubscription = <ThrowOnError extends boolean = false>(options?: Options<PostUnattendedCompositionCreateSubscriptionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostUnattendedCompositionCreateSubscriptionResponses, PostUnattendedCompositionCreateSubscriptionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/UnattendedComposition/CreateSubscription',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const get = <ThrowOnError extends boolean = false>(options?: Options<GetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/',
        ...options
    });
};

export const deleteYubiqAdministrationDeleteSubscription = <ThrowOnError extends boolean = false>(options?: Options<DeleteYubiqAdministrationDeleteSubscriptionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<DeleteYubiqAdministrationDeleteSubscriptionResponses, DeleteYubiqAdministrationDeleteSubscriptionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/DeleteSubscription',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Creates a new tenant. Only accessible to Yubiq Administrators.
 */
export const postYubiqAdministrationCreateTenant = <ThrowOnError extends boolean = false>(options?: Options<PostYubiqAdministrationCreateTenantData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostYubiqAdministrationCreateTenantResponses, PostYubiqAdministrationCreateTenantErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/CreateTenant',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Updates an existing tenant. Only accessible to Yubiq Administrators.
 */
export const postYubiqAdministrationUpdateTenant = <ThrowOnError extends boolean = false>(options?: Options<PostYubiqAdministrationUpdateTenantData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostYubiqAdministrationUpdateTenantResponses, PostYubiqAdministrationUpdateTenantErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/UpdateTenant',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Disables a tenant. Only accessible to Yubiq Administrators.
 */
export const postYubiqAdministrationDisableTenant = <ThrowOnError extends boolean = false>(options?: Options<PostYubiqAdministrationDisableTenantData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostYubiqAdministrationDisableTenantResponses, PostYubiqAdministrationDisableTenantErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/DisableTenant',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retrieves all tenants including disabled ones. Only accessible to Yubiq Administrators.
 */
export const getYubiqAdministrationGetAllTenants = <ThrowOnError extends boolean = false>(options?: Options<GetYubiqAdministrationGetAllTenantsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetYubiqAdministrationGetAllTenantsResponses, GetYubiqAdministrationGetAllTenantsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/GetAllTenants',
        ...options
    });
};

export const getYubiqAdministrationGetSeals = <ThrowOnError extends boolean = false>(options?: Options<GetYubiqAdministrationGetSealsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetYubiqAdministrationGetSealsResponses, GetYubiqAdministrationGetSealsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/GetSeals',
        ...options
    });
};

export const postYubiqAdministrationCreateSeal = <ThrowOnError extends boolean = false>(options?: Options<PostYubiqAdministrationCreateSealData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostYubiqAdministrationCreateSealResponses, PostYubiqAdministrationCreateSealErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/CreateSeal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postYubiqAdministrationUpdateSeal = <ThrowOnError extends boolean = false>(options?: Options<PostYubiqAdministrationUpdateSealData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostYubiqAdministrationUpdateSealResponses, PostYubiqAdministrationUpdateSealErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/UpdateSeal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postYubiqAdministrationDeleteSeal = <ThrowOnError extends boolean = false>(options?: Options<PostYubiqAdministrationDeleteSealData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostYubiqAdministrationDeleteSealResponses, PostYubiqAdministrationDeleteSealErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/DeleteSeal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getYubiqAdministrationGetSealDefinitions = <ThrowOnError extends boolean = false>(options?: Options<GetYubiqAdministrationGetSealDefinitionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetYubiqAdministrationGetSealDefinitionsResponses, GetYubiqAdministrationGetSealDefinitionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/GetSealDefinitions',
        ...options
    });
};

export const postYubiqAdministrationCreateTenantDocument = <ThrowOnError extends boolean = false>(options?: Options<PostYubiqAdministrationCreateTenantDocumentData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostYubiqAdministrationCreateTenantDocumentResponses, PostYubiqAdministrationCreateTenantDocumentErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/CreateTenantDocument',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

export const getYubiqAdministrationGetTenantDocumentById = <ThrowOnError extends boolean = false>(options: Options<GetYubiqAdministrationGetTenantDocumentByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetYubiqAdministrationGetTenantDocumentByIdResponses, GetYubiqAdministrationGetTenantDocumentByIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/GetTenantDocumentById',
        ...options
    });
};

export const getYubiqAdministrationGetTenantDocuments = <ThrowOnError extends boolean = false>(options: Options<GetYubiqAdministrationGetTenantDocumentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetYubiqAdministrationGetTenantDocumentsResponses, GetYubiqAdministrationGetTenantDocumentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/GetTenantDocuments',
        ...options
    });
};

export const postYubiqAdministrationDeleteTenantDocument = <ThrowOnError extends boolean = false>(options?: Options<PostYubiqAdministrationDeleteTenantDocumentData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostYubiqAdministrationDeleteTenantDocumentResponses, PostYubiqAdministrationDeleteTenantDocumentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/DeleteTenantDocument',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getYubiqAdministrationGetTenantHierarchyEdges = <ThrowOnError extends boolean = false>(options?: Options<GetYubiqAdministrationGetTenantHierarchyEdgesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetYubiqAdministrationGetTenantHierarchyEdgesResponses, GetYubiqAdministrationGetTenantHierarchyEdgesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/GetTenantHierarchyEdges',
        ...options
    });
};

export const postYubiqAdministrationCreateTenantHierarchyEdge = <ThrowOnError extends boolean = false>(options?: Options<PostYubiqAdministrationCreateTenantHierarchyEdgeData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostYubiqAdministrationCreateTenantHierarchyEdgeResponses, PostYubiqAdministrationCreateTenantHierarchyEdgeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/CreateTenantHierarchyEdge',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postYubiqAdministrationDisableTenantHierarchyEdge = <ThrowOnError extends boolean = false>(options?: Options<PostYubiqAdministrationDisableTenantHierarchyEdgeData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostYubiqAdministrationDisableTenantHierarchyEdgeResponses, PostYubiqAdministrationDisableTenantHierarchyEdgeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/DisableTenantHierarchyEdge',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getYubiqAdministrationGetTenantHierarchyEdge = <ThrowOnError extends boolean = false>(options: Options<GetYubiqAdministrationGetTenantHierarchyEdgeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetYubiqAdministrationGetTenantHierarchyEdgeResponses, GetYubiqAdministrationGetTenantHierarchyEdgeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/YubiqAdministration/GetTenantHierarchyEdge',
        ...options
    });
};